import { render, staticRenderFns } from "./AlternativeLanguageSection.vue?vue&type=template&id=149cf60e&scoped=true&"
import script from "./AlternativeLanguageSection.vue?vue&type=script&lang=js&"
export * from "./AlternativeLanguageSection.vue?vue&type=script&lang=js&"
import style0 from "./AlternativeLanguageSection.vue?vue&type=style&index=0&id=149cf60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149cf60e",
  null
  
)

export default component.exports